import React from 'react'
import Navbar from '../components/Navbar'
import Pricing from '../components/Pricing'
import Footer from '../components/Footer'


const Pricingpage = () => {
  return (
    <div className='bg-[#333]'>
      <Navbar/>
      <Pricing/>
      <Footer/>
    </div>
  )
}

export default Pricingpage
